import React from 'react';
import BaseDialog from '../../components/dialog/BaseDialog';
import {
	useTranslate,
	SelectInput,
	required,
	useNotify,
	useUpdate
} from 'react-admin';
import IconSettings from '@material-ui/icons/Settings';
import { Form } from 'react-final-form';

const UpdateTrafficType = ({ record, version }) => {
	const translate = useTranslate();
	const notify = useNotify();
	const [updateTrafficType] = useUpdate('accountingAccounts');

	const handleSubmit = (values, hideDialog) => {
		updateTrafficType(
			{
				payload: {
					id: record.id,
					data: values,
					action: 'UpdateTrafficType',
				},
			},
			{
				onSuccess: () => {
					notify('resources.accountingAccounts.notifications.trafficTypeUpdated');
					hideDialog();
				},
				onFailure: (error) => {
					notify(error.message, 'error');
				},
			},
		);
	};

	return (
		<BaseDialog
			icon={<IconSettings />}
			buttonLabel={translate('resources.accountingAccounts.actions.updateTrafficType')}
			dialogTitle={translate('resources.accountingAccounts.actions.updateTrafficType')}
			handleSubmit={handleSubmit}
		>
			{({ handleSubmit, hideDialog }) => (
				<Form
					initialValues={record}
					onSubmit={values => handleSubmit(values, hideDialog)}
					key={version}
					keepDirtyOnReinitialize
					render={({ handleSubmit }) => (
						<form onSubmit={handleSubmit}>
							<p>
								{translate('resources.accountingAccounts.labels.updateTrafficTypeWarning')}
							</p>
							<SelectInput
								source="trafficType"
								choices={[
									{ id: 'LOW', name: 'LOW' },
									{ id: 'MIXED', name: 'MIXED' },
									{ id: 'HIGH', name: 'HIGH' },
									{ id: 'MIGRATE_TO_LOW', name: 'MIGRATE_TO_LOW' },
								]}
								validate={required()}
								fullWidth
							/>
						</form>
					)}
				/>
			)}
		</BaseDialog>
	);
};

export default UpdateTrafficType;
